//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [],
  created () {},
  mounted () {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    onIndex () {
      this.$router.push({
        path: '/'
      })
    },
    handleView (path) {
      this.$router.push({
        path
      })
    }
  }
}
